import { render, staticRenderFns } from "./work.vue?vue&type=template&id=055d1daa&scoped=true&"
import script from "./work.vue?vue&type=script&lang=js&"
export * from "./work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d1daa",
  null
  
)

export default component.exports